import { string } from 'io-ts/Decoder';

// Difficulty rating names are configuration-driven, so any name is accepted
// here; 'unknown' is the no-rating option.
export const DifficultyWithUnknown = string;
